import { sortedItems } from "src/library/sortedItems";

export function setCoachingTracks(state, coachingTracks) {
  state.coachingTracks = [];

  coachingTracks.forEach(function(coachingBlock) {
    coachingBlock.selected = false;
    state.coachingTracks.push(coachingBlock);
  });

  if (state.coachingTracks.length) state.coachingTracks[0].selected = true;
}

export function setCoachCoachingBlocks(state, coachingBlocks) {
  state.coachCoachingBlocks = []

  coachingBlocks.forEach(function(coachingBlock) {
      coachingBlock.selected = false
      state.coachCoachingBlocks.push(coachingBlock)
  })

  if (state.coachCoachingBlocks.length)
      state.coachCoachingBlocks[0].selected = true
}


export function clearRegistrationCode(state) {
  state.registration_code = null;
}

export function resetStore(state) {
  state.coachingTracks = [];
  state.registration_code = "";
}

export function setLastUpdated(state) {
  state.lastUpdated = new Date().getTime();
}

export function isDataLoaded(state, status) {
  state.isDataLoaded = status;
}

export function isDropInDataLoaded(state, status) {
  state.isDropInDataLoaded = status;
}

export function isCTDataLoaded(state, status) {
  state.isCTDataLoaded = status;
}

export function isCoachingBlocksDataLoaded(state, status) {
  state.coachingBlocksDataLoaded = status;
}


//-----Drop-Ins-----//
export function setDropIns(state, props) {
  let data = props.data;

  data.filter(function(item) {
    if (
      state.registerDropInCoachingSession &&
      item._id == state.registerDropInCoachingSession._id
    ) {
      state.registerDropInCoachingSession = item;
    }
    item.isRegisted = false;
    item.coachingtrackslots.filter(function(slot) {
      if(!item.isRegisted)
        (item.isRegisted =
          slot?.user_ids.length > 0 && slot.user_ids.find(id => props.authUser._id == id)
            ? true
            : false);
    });
    return item = sortedItems(item.slots);
  });

  data.sort((a, b) => (a.isRegisted > b.isRegisted ? -1 : 1));
  state.dropIns = data;
}
export function setRegisterDropInCoachingSession(state, props) {
  state.registerDropInCoachingSession = props;
}
export function setRegisterDropInCoachingSessionDialog(state, props) {
  state.registerDropInCoachingSessionDialog = props;
}
export function setCalcelDropInCoachingSessionDialog(state, props) {
  state.calcelDropInCoachingSessionDialog = props;
}
export function setPreviousComponent(state, props) {
  state.previousComponent = props;
}
export function setChangeRegistrationDropInDialog(state, props) {
  state.changeRegistrationDropInDialog = props;
}
export function setRegisterDropInCoachingSessionLevel(state, props) {
  state.registerDropInCoachingSessionLevel = props;
}
export function setRegisterDropInCoachingSessionLevelType(state, props) {
  state.registerDropInCoachingSessionLevelType = props;
}
export function setRegisterDropInCoachingSessionLevelEvent(state, props) {
  state.registerDropInCoachingSessionLevelEvent = props;
}
export function setRegisterDropInCoachingSessionLevelConfirmed(state, props) {
  state.registerDropInCoachingSessionLevelConfirmed = props;
}
export function setRegisterDropInCoachingSessionLevelDialog(state, props) {
  state.registerDropInCoachingSessionLevelDialog = props;
}
export function setViewMoreDropInCoachingSessionDialog(state, props) {
  state.viewMoreDropInCoachingSessionDialog = props;
}
export function setConfirmWaitlistDialog(state, props) {
  state.confirmWaitlistDialog = props;
}
export function setRegisterWaitlistDropInCoachingSessionConfirmed(state, props) {
  state.registerWaitlistDropInCoachingSessionConfirmed = props;
}
export function setDropInCoachingSessionIsFullDialog(state, props) {
  state.dropInCoachingSessionIsFullDialog = props;
}

//-----Coaching-Track-----//
export function setCoachingBlocks(state, props) {
  let data = props.data;

  data.filter(function(item) {
    if (
      state.registerCoachingTrack &&
      item._id == state.registerCoachingTrack._id
    ) {
      state.registerCoachingTrack = item;
    }

    item.isRegisted = false;
    item.coachingtrackslots.filter(function(slot) {
      if(!item.isRegisted)
        (item.isRegisted =
          slot?.user_ids.length > 0 && slot.user_ids.find(id => props.authUser._id == id)
            ? true
            : false);
    })
    return item = sortedItems(item.slots);
  });

  data.sort((a, b) => (a.isRegisted > b.isRegisted ? -1 : 1));
  state.coachingBlocks = data;
}
export function setRegisterCoachingTrack(state, props) {
  state.registerCoachingTrack = props;
}
export function setRegisterCoachingTrackDialog(state, props) {
  state.registerCoachingTrackDialog = props;
}
export function setConfirmRegisterCoachingTrackDialog(state, props) {
  state.confirmRegisterCoachingTrackDialog = props;
}
export function setCancelRegisterCoachingTrackDialog(state, props) {
  state.cancelRegisterCoachingTrackDialog = props;
}
export function setViewMoreCoachingTrackDialog(state, props) {
  state.viewMoreCoachingTrackDialog = props;
}
export function setChangeRegistrationCtDialog(state, props) {
  state.changeRegistrationCtDialog = props;
}
//-----Mind-Break-----//
export function setRegisterMindBreak(state, props) {
  state.registerMindBreak = props;
}
export function setRegisterMindBreakDialog(state, props) {
  state.registerMindBreakDialog = props;
}
export function setViewMoreMindBreakDialog(state, props) {
  state.viewMoreMindBreakDialog = props;
}
